/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateTuitionRateTierRequest
 */
export interface UpdateTuitionRateTierRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateTuitionRateTierRequest
     */
    tuitionRatePlanId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof UpdateTuitionRateTierRequest
     */
    minQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTuitionRateTierRequest
     */
    maxQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTuitionRateTierRequest
     */
    amount: number;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateTuitionRateTierRequest
     */
    sortOrder: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the UpdateTuitionRateTierRequest interface.
 */
export function instanceOfUpdateTuitionRateTierRequest(value: object): value is UpdateTuitionRateTierRequest {
    if (!('tuitionRatePlanId' in value) || value['tuitionRatePlanId'] === undefined) return false;
    if (!('minQuantity' in value) || value['minQuantity'] === undefined) return false;
    if (!('maxQuantity' in value) || value['maxQuantity'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function UpdateTuitionRateTierRequestFromJSON(json: any): UpdateTuitionRateTierRequest {
    return UpdateTuitionRateTierRequestFromJSONTyped(json, false);
}

export function UpdateTuitionRateTierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTuitionRateTierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tuitionRatePlanId': ApiUserTasksGetPageParameterFromJSON(json['tuitionRatePlanId']),
        'minQuantity': json['minQuantity'],
        'maxQuantity': json['maxQuantity'],
        'amount': json['amount'],
        'sortOrder': ApiUserTasksGetPageParameterFromJSON(json['sortOrder']),
    };
}

export function UpdateTuitionRateTierRequestToJSON(json: any): UpdateTuitionRateTierRequest {
    return UpdateTuitionRateTierRequestToJSONTyped(json, false);
}

export function UpdateTuitionRateTierRequestToJSONTyped(value?: UpdateTuitionRateTierRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tuitionRatePlanId': ApiUserTasksGetPageParameterToJSON(value['tuitionRatePlanId']),
        'minQuantity': value['minQuantity'],
        'maxQuantity': value['maxQuantity'],
        'amount': value['amount'],
        'sortOrder': ApiUserTasksGetPageParameterToJSON(value['sortOrder']),
    };
}

